import type { DateRangePreset } from '../components/Toolbar';

const PRESET_MS: Record<Exclude<DateRangePreset, 'all'>, number> = {
  '24h': 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
  '30d': 30 * 24 * 60 * 60 * 1000,
};

/** ISO start time for a date-range preset, or null for "all". */
export function cutoffIsoFor(
  range: DateRangePreset,
  now: number = Date.now(),
): string | null {
  if (range === 'all') return null;
  return new Date(now - PRESET_MS[range]).toISOString();
}
